(function () {
  function initCrossfade(root) {
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-crossfade-slide]')
    );
    if (slides.length <= 1) return;

    var duration =
      parseInt(root.getAttribute('data-crossfade-duration'), 10) || 4000;
    var currentIndex = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (currentIndex === -1) currentIndex = 0;

    var timer = null;
    var isPaused = false;

    var prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    if (prefersReducedMotion) return; // garde la 1ère slide fixe, pas d'auto-rotation

    function goToNext() {
      if (isPaused) return;
      slides[currentIndex].classList.remove('is-active');
      currentIndex = (currentIndex + 1) % slides.length;
      slides[currentIndex].classList.add('is-active');
    }

    function start() {
      timer = setInterval(goToNext, duration);
    }

    function stop() {
      clearInterval(timer);
    }

    root.addEventListener('mouseenter', function () {
      isPaused = true;
    });
    root.addEventListener('mouseleave', function () {
      isPaused = false;
    });

    start();
  }

  function initAll() {
    var wraps = document.querySelectorAll('[data-crossfade]');
    wraps.forEach(initCrossfade);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();